import { useQuery } from "@tanstack/react-query";
import { getDailyTaskDwo } from "../api/tasks";
import { DailyTaskDwo } from "../types/dailyTaskDwo";

export const dwoTaskKeys = {
  all: ["hr-daily-task-dwo"] as const,
  list: (attendanceId: string) =>
    [...dwoTaskKeys.all, "list", attendanceId] as const,
};

export const useDailyTaskDwo = (attendanceId: string) => {
  return useQuery<DailyTaskDwo[]>({
    queryKey: dwoTaskKeys.list(attendanceId),
    queryFn: () => getDailyTaskDwo(attendanceId),
    enabled: !!attendanceId,
    staleTime: 1000 * 60 * 60 * 3,
    gcTime: 1000 * 60 * 60 * 3,
    refetchOnWindowFocus: true,
  });
};
